const sendAppLoaded = () => {
  if (window.parent) {
    window.parent.postMessage(
      {
        event: 'chrome_ext_loaded'
      },
      '*'
    );
  }
};

const sendNavigatedAway = () => {
  if (window.parent) {
    window.parent.postMessage(
      {
        event: 'chrome_ext_navigated_away'
      },
      '*'
    );
  }
};

const sendPostEditorClosed = (success: boolean) => {
  if (window.parent) {
    window.parent.postMessage(
      {
        event: 'chrome_ext_close',
        saved: success
      },
      '*'
    );
  }
};

const sendError = (message?: string) => {
  if (window.parent) {
    window.parent.postMessage(
      {
        event: 'chrome_ext_error',
        message: message || ''
      },
      '*'
    );
  }
};

export const chromeExtensionHelpers = {
  sendAppLoadedMessage: sendAppLoaded,
  sendNavigatedAwayMessage: sendNavigatedAway,
  sendPostEditorClosedMessage: sendPostEditorClosed,
  sendErrorMessage: sendError
};
